import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ZoomInIcon } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/4oUEUynuZPi1L5oRki7KwM/download_(3).png', 'https://cdn.magicpatterns.com/uploads/noRonfkFvEGEVmZXgXRQ4r/download_(4).png', 'https://cdn.magicpatterns.com/uploads/6UTjn6UxydikuuM98AXCGP/Captura_de_pantalla_2026-04-17_a_las_15.01.56.png', 'https://cdn.magicpatterns.com/uploads/ksgYugm8Pa5JQbMWCNDrYv/Captura_de_pantalla_2026-04-17_a_las_15.00.57.png', 'https://cdn.magicpatterns.com/uploads/pMgaJM1usm7E8sUALYHgtT/WhatsApp_Image_2026-04-27_at_16.58.06.jpg', 'https://cdn.magicpatterns.com/uploads/1trh34rao8DZWvecYw3pUZ/Captura_de_pantalla_2026-04-17_a_las_15.01.41.png', 'https://cdn.magicpatterns.com/uploads/f4UjvbVTFvC5TP7C4md87c/WhatsApp_Image_2026-04-27_at_17.03.32.jpg', 'https://cdn.magicpatterns.com/uploads/7nc1ZUQZYuy6rQNaLDUeyX/Captura_de_pantalla_2026-04-17_a_las_15.00.37.png', 'https://cdn.magicpatterns.com/uploads/rHjP7fGanNXL6Fibv5UAnJ/WhatsApp_Image_2026-04-27_at_16.58.18.jpg', 'https://cdn.magicpatterns.com/uploads/dabSJ1gBHWuLsD4Bem7Le7/WhatsApp_Image_2026-04-27_at_17.04.18.jpg', 'https://cdn.magicpatterns.com/uploads/cnubUTM1mqn1ZxvmEM841T/WhatsApp_Image_2026-04-27_at_16.31.29.jpg', 'https://cdn.magicpatterns.com/uploads/czyTYDeTmADrQUYXqE1CTw/WhatsApp_Image_2026-04-27_at_16.31.30.jpg', 'https://cdn.magicpatterns.com/uploads/mxDCDACSNQm7FUGMSjGx27/WhatsApp_Image_2026-04-27_at_16.57.18.jpg', 'https://cdn.magicpatterns.com/uploads/7EsAibVEQPhGfeBzByj85p/WhatsApp_Image_2026-05-03_at_13.06.11_(4).jpg', 'https://cdn.magicpatterns.com/uploads/rTSUPy5fS11Lp5PWv6KpPf/WhatsApp_Image_2026-05-03_at_13.06.11.jpg'];
export function Gallery() {
  const {
    t
  } = useLanguage();
  const [selectedImg, setSelectedImg] = useState<string | null>(null);
  return <section id="gallery" className="py-32 lg:py-44 bg-warmWhite relative" data-id="element-102">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10" data-id="element-103">
        <div className="text-center mb-20" data-id="element-104">
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex items-center justify-center gap-5 mb-6" data-id="element-105">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-sand/50" data-id="element-106"></div>
            <span className="text-sand text-[11px] font-medium tracking-[0.35em] uppercase" data-id="element-107">
              {t.gallery.subtitle}
            </span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-sand/50" data-id="element-108"></div>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1,
          duration: 0.8
        }} className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] text-navy" data-id="element-109">
            {t.gallery.title}
          </motion.h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 auto-rows-[200px] sm:auto-rows-[260px] lg:auto-rows-[320px]" data-id="element-110">
          {images.map((img, index) => {
          // Irregular grid layout logic
          let spanClasses = '';
          if (index === 0) spanClasses = 'col-span-2 row-span-2'; // Tall hero
          else if (index === 1) spanClasses = 'col-span-1 row-span-1'; // Standard
          else if (index === 2) spanClasses = 'col-span-1 row-span-2'; // Tall
          else if (index === 3) spanClasses = 'col-span-1 row-span-1'; // Standard
          else if (index === 4) spanClasses = 'col-span-2 row-span-1'; // Wide
          else if (index === 5) spanClasses = 'col-span-1 row-span-1'; // Standard
          else if (index === 6) spanClasses = 'col-span-1 row-span-1'; // Standard
          else if (index === 7) spanClasses = 'col-span-2 row-span-1'; // Wide/Cinematic
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08,
            duration: 0.8,
            ease: [0.4, 0, 0.2, 1]
          }} className={`relative overflow-hidden cursor-pointer group rounded-xs shadow-soft hover:shadow-elegant transition-shadow duration-500 ${spanClasses}`} onClick={() => setSelectedImg(img)} data-id="element-111">
                <div className="w-full h-full" data-id="element-112">
                  <img src={img} alt={`Gallery ${index + 1}`} className="w-full h-full object-cover transition-transform duration-[1.2s] ease-elegant group-hover:scale-105" data-id="element-113" />
                </div>
                <div className="absolute inset-0 bg-navy/0 group-hover:bg-navy/20 transition-all duration-700 flex items-center justify-center" data-id="element-114">
                  <div className="opacity-0 group-hover:opacity-100 transition-all duration-700 transform translate-y-4 group-hover:translate-y-0" data-id="element-115">
                    <ZoomInIcon className="w-7 h-7 text-white drop-shadow-md" data-id="element-116" />
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 section-divider" data-id="element-117" />

      {/* Lightbox */}
      <AnimatePresence data-id="element-118">
        {selectedImg && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-[100] bg-navy-dark/95 backdrop-blur-sm flex items-center justify-center p-6" onClick={() => setSelectedImg(null)} data-id="element-119">
            <button className="absolute top-8 right-8 text-white/60 hover:text-white transition-colors duration-300" onClick={() => setSelectedImg(null)} data-id="element-120">
              <XIcon className="w-7 h-7" data-id="element-121" />
            </button>
            <motion.img initial={{
          scale: 0.92,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.92,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: [0.4, 0, 0.2, 1]
        }} src={selectedImg} alt="Full screen" className="max-w-full max-h-[85vh] object-contain rounded-xs shadow-2xl ring-1 ring-white/10" onClick={e => e.stopPropagation()} data-id="element-122" />
          </motion.div>}
      </AnimatePresence>
    </section>;
}